function DetailShow () {
  var self = this;

  this.init = function () {
    self.isWide = '-';
    self.setFirst();
    self.checkWidths();
    window.addEventListener('windowResize', self.checkWidths);
  };

  this.checkWidths = function () {
    var isWide = Bonkers.width.atLeast('tablet');
    if (self.isWide === isWide) {
      return;
    }
    self.isWide = isWide;
    if (isWide) {
      $('.details-card__heading').on('click.preventToggle', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      $('.details-card__collapsible').off('show.bs.collapse');
      $('.details-card__collapsible').collapse('show');
    } else {
      $('.details-card__heading').off('click.preventToggle');
      var $hideable = self.$first ? $('.details-card__collapsible').not(self.$first) : $('.details-card__collapsible');
      $hideable.collapse('hide');

      $('.details-card__collapsible').on('show.bs.collapse', function () {
        $('.details-card__collapsible').not($(this)).collapse('hide');
      });
      $('.details-card__collapsible').on('hidden.bs.collapse', function () {
        $(this).removeClass('show');
      });
    }
  };

  this.setFirst = function () {
    if (!$('.product-details').length) {
      return;
    }
    if ($('.details-block .-order').length) {
      self.$first = $('.details-block .-order:first .details-card:first .details-card__collapsible');
    } else {
      self.$first = $('.details-card__collapsible:first');
    }
  };
}

$(function () {
  var detailShow = new DetailShow();
  detailShow.init();
});
